import { PARAM_CHANGE } from '@store/actions';
import BLOCKS from '@store/blocks';

export function TEST_SELECTION(store, testName) {
  PARAM_CHANGE(store, BLOCKS.TEST_PANELS.ACTIVE_TEST, testName);

  RESET_MAP_PICKABLE_PARAMS(store);
}

function RESET_MAP_PICKABLE_PARAMS(store) {
  PARAM_CHANGE(store, BLOCKS.MAP.CROSSHAIR_SETTING, -1);
  PARAM_CHANGE(store, BLOCKS.MAP.ACTIVE_MARKERS, [
    { x: -1, y: -1 },
    { x: -1, y: -1 },
  ]);
  PARAM_CHANGE(store, BLOCKS.MAP.PICKING_MARKER, { x: -1, y: -1 });
}

/* Needed to consider a special case of moving the crosshair while in the wrong mode */
export function CROSSHAIR_MOVE_DRIVING(store, pos) {
  PARAM_CHANGE(store, BLOCKS.MAP.ACTIVE_MARKERS, [
    pos,
    BLOCKS.MAP.ACTIVE_MARKERS[1],
  ]);
}

export function OPEN_POPUP(store, type) {
  PARAM_CHANGE(store, BLOCKS.APP.POPUP, type);
}
/*
export function CROSSHAIR_SETUP_DRIVING(store) {
  const activeMarker = store.get(BLOCKS.MAP.ACTIVE_MARKERS);
  let markers = [activeMarker[0], activeMarker[1]];

  markers[0] = store.get(BLOCKS.MAP.PICKING_MARKER);
  PARAM_CHANGE(store, BLOCKS.MAP.ACTIVE_MARKERS, markers);
}*/
